module.exports = __webpack_public_path__ + "media/images/icons/replace_icon-fe893a7fd046983792c33708882b3833.svg";